import { CardElement } from "@stripe/react-stripe-js";

import { createMarkup } from "../../utils";

import "./styles.css";

const InputStripe = ({ name, label, reqd }) => {
	return (
		<div className="stripe">
			<label htmlFor={name} className="control-label">
				<span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
				{reqd && <span className="reqd">*</span>}
			</label>
			<CardElement hidePostalCode={true} />
		</div>
	);
};

export default InputStripe;
